<template>
  <div class="property-filter">
    <div class="property-filter__header">Refine Your<br>Search Below</div>
    <template v-if="['package', 'dwelling', 'townhouses'].includes(type)">
      <template v-if="styleTemplate.filter.dwellings.builder && builderSelections.length > 1">
        <label :style="`color: ${styleTemplate['filter']['heading-colour']};`">SELECT BUILDER</label>
        <input-dropdown
          class="property-filter__input"
          :selections="builderSelections"
          v-model="inputBuilder"
        />
      </template>

      <template v-if="styleTemplate.filter.dwellings.colourScheme && colourSchemeSelections.length > 1">
        <label :style="`color: ${styleTemplate['filter']['heading-colour']};`">SELECT COLOUR SCHEME</label>
        <input-dropdown
          class="property-filter__input"
          :selections="colourSchemeSelections"
          v-model="inputColourScheme"
        />
      </template>

      <template v-if="styleTemplate.filter.dwellings.houseDesign && houseDesignSelections.length > 1">
        <label :style="`color: ${styleTemplate['filter']['heading-colour']};`">SELECT HOUSE DESIGN</label>
        <input-dropdown
          class="property-filter__input"
          :selections="houseDesignSelections"
          v-model="inputHouseDesign"
        />
      </template>
    </template>

    <template
      v-if="selectedPriceRange[0] !== undefined && 
            selectedPriceRange[1] !== undefined &&
            inputPriceRange[0] !== inputPriceRange[1]"
    >
      <label :style="`color: ${styleTemplate['filter']['heading-colour']};`">PRICE - ${{ selectedPriceRange[0] }}k to ${{ selectedPriceRange[1] }}k</label>
      <input-range-select-2
        class="property-filter__input"
        :max="inputPriceRange[1]"
        :min="inputPriceRange[0]"
        unitsAfter="k"
        unitsBefore="$"
        v-model="inputPriceRange"
        @value-changed="updateSelectedRange('price', $event)"
      />
    </template>


    <template
      v-if="['package', 'land', 'townhouses', 'houses'].includes(type) &&
            inputLotSizeRange[0] !== undefined &&
            inputLotSizeRange[1] !== undefined &&
            inputLotSizeRange[0] !== inputLotSizeRange[1]"
    >
      <label :style="`color: ${styleTemplate['filter']['heading-colour']};`">LOT SIZE - {{ selectedLotSizeRange[0] }}m<sup>2</sup> to {{ selectedLotSizeRange[1] }}m<sup>2</sup></label>
      <input-range-select-2
        class="property-filter__input"
        :key="inputLotSizeRange[0] + 'lot' + inputLotSizeRange[1]"
        :max="inputLotSizeRange[1]"
        :min="inputLotSizeRange[0]"
        unitsAfter="m<sup>2</sup>"
        v-model="inputLotSizeRange"
        @value-changed="updateSelectedRange('lotSize', $event)"
      />
    </template>

    <template v-if="['package', 'townhouses', 'dwelling', 'apartments', 'houses'].includes(type) &&
                    inputDwellingSizeRange[0] !== undefined &&
                    inputDwellingSizeRange[1] !== undefined &&
                    inputDwellingSizeRange[0] !== inputDwellingSizeRange[1]"
    >
      <label :style="`color: ${styleTemplate['filter']['heading-colour']};`">LIVING SIZE - {{ selectedDwellingSizeRange[0] }}m<sup>2</sup> to {{ selectedDwellingSizeRange[1] }}m<sup>2</sup></label>
      <input-range-select-2
        class="property-filter__input"
        :key="inputDwellingSizeRange[0] + 'dwelling' + inputDwellingSizeRange[1]"
        :max="inputDwellingSizeRange[1]"
        :min="inputDwellingSizeRange[0]"
        unitsAfter="m<sup>2</sup>"
        v-model="inputDwellingSizeRange"
        @value-changed="updateSelectedRange('dwellingSize', $event)"
      />
    </template>

    <template v-if="['package', 'dwelling', 'townhouses', 'apartments', 'houses'].includes(type)">
      <template v-if="getActiveSelections(bedsSelections) > 1">
        <label :style="`color: ${styleTemplate['filter']['heading-colour']};`">Bedrooms</label>
        <input-radio-select
          class="property-filter__input"
          :selections="bedsSelections"
          v-model="inputBeds"
        />
      </template>

      <template v-if="getActiveSelections(bathsSelections) > 1">
        <label :style="`color: ${styleTemplate['filter']['heading-colour']};`">Bathrooms</label>
        <input-radio-select
          class="property-filter__input"
          :selections="bathsSelections"
          v-model="inputBaths"
        />
      </template>

      <template v-if="getActiveSelections(carsSelections) > 1">
        <label :style="`color: ${styleTemplate['filter']['heading-colour']};`">Car Spaces</label>
        <input-radio-select
          class="property-filter__input"
          :selections="carsSelections"
          v-model="inputCars"
        />
      </template>
    </template>

    <template v-if="type === 'land'">
      <br><br>
      <div class="property-filter__header" :style="`color: ${styleTemplate['filter']['heading-colour']};`">Search By<br>Lot Number</div>
      <input-keypad
        class="property-filter__input"
        v-model="inputLotNumber"
      />
    </template>
  </div>
</template>
<script>
import InputDropdown from './InputDropdown'
import InputKeypad from './InputKeypad'
import InputRadioSelect from './InputRadioSelect'
import InputRangeSelect2 from './InputRangeSelect2'
import _ from 'lodash'

export default {
  props: ['type'],

  components: { InputDropdown, InputKeypad, InputRadioSelect, InputRangeSelect2 },

  data () {
    return {
      bathsSelections: [
        { label: '1', value: 1, disabled: false },
        { label: '2', value: 2, disabled: false },
        { label: '3', value: 3, disabled: false },
        { label: '4+', value: 4, disabled: false },
      ],
      bedsSelections: [
        { label: '1', value: 1, disabled: false },
        { label: '2', value: 2, disabled: false },
        { label: '3', value: 3, disabled: false },
        { label: '4+', value: 4, disabled: false }
      ],
      carsSelections: [
        { label: '1', value: 1, disabled: false },
        { label: '2', value: 2, disabled: false },
        { label: '3', value: 3, disabled: false },
        { label: '4+', value: 4, disabled: false },
      ],
      selectedPriceRange: [0, 0],
      selectedLotSizeRange: [0, 0],
      selectedDwellingSizeRange: [0, 0],
    }
  },

  computed: {
    builderSelections () {
      let builders = []

      if (this.activePackages) {
        this.packages.forEach(_package => {
          if (_package.active && _package.dwelling.builderLabel) {
            builders.push({
              label: _package.dwelling.builderLabel,
              value: _package.dwelling.builderLabel
            })
          }
        })
      }

      if (this.filterType === 'packages') {
        this.packages.forEach(_package => {
          if (_package.active && _package.dwelling.builderLabel) {
            builders.push({
              label: _package.dwelling.builderLabel,
              value: _package.dwelling.builderLabel
            })
          }
        })
      }

      if (this.filterType === 'dwellings') {
        this.dwellings.forEach(dwelling => {
          if (dwelling.active && dwelling.builderLabel) {
            builders.push({
              label: dwelling.builderLabel,
              value: dwelling.builderLabel
            })
          }
        })
      }

      if (this.filterType === 'townhouses') {
        this.activeProperties.forEach(property => {
          if (property.active && property.dwelling.builderLabel) {
            builders.push({
              label: property.dwelling.builderLabel,
              value: property.dwelling.builderLabel
            })
          }
        })
      }

      builders = _.sortBy(_.uniqBy(builders, 'label'), 'label')
      builders.unshift({ label: 'Any', value: '' })
      return builders
    },

    colourSchemeSelections () {
      let schemes = []

      if (this.activePackages) {
        this.packages.forEach(_package => {
          if (_package.active && _package.dwelling && _package.dwelling.colourScheme) {
            schemes.push({
              label: _package.dwelling.colourScheme,
              value: _package.dwelling.colourScheme
            })
          }
        })
      }

      if (this.filterType === 'packages') {
        this.packages.forEach(_package => {
          if (_package.active && _package.dwelling && _package.dwelling.colourScheme) {
            schemes.push({
              label: _package.dwelling.colourScheme,
              value: _package.dwelling.colourScheme
            })
          }
        })
      }

      if (this.type === 'dwelling') {
        this.dwellings.forEach(dwelling => {
          if (dwelling.active && dwelling.colourScheme) {
            schemes.push({
              label: dwelling.colourScheme,
              value: dwelling.colourScheme
            })
          }
        })
      }

      if (this.type === 'townhouses') {
        this.activeProperties.forEach(property => {
          if (property.active && property.dwelling && property.dwelling.colourScheme) {
            schemes.push({
              label: property.dwelling.colourScheme,
              value: property.dwelling.colourScheme
            })
          }
        })
      }

      schemes = _.sortBy(_.uniqBy(schemes, 'label'), 'label')
      schemes.unshift({ label: 'Any', value: '' })
      return schemes
    },

    houseDesignSelections () {
      let designs = []

      if (this.activePackages) {
        this.packages.forEach(_package => {
          if (_package.active && _package.dwelling && _package.dwelling.houseDesign) {
            designs.push({
              label: _package.dwelling.houseDesign,
              value: _package.dwelling.houseDesign
            })
          }
        })
      }

      if (this.filterType === 'packages') {
        this.packages.forEach(_package => {
          if (_package.active && _package.dwelling.houseDesign) {
            designs.push({
              label: _package.dwelling.houseDesign,
              value: _package.dwelling.houseDesign
            })
          }
        })
      }

      if (this.type === 'dwelling') {
        this.dwellings.forEach(dwelling => {
          if (dwelling.active && dwelling.houseDesign) {
            designs.push({
              label: dwelling.houseDesign,
              value: dwelling.houseDesign
            })
          }
        })
      }

      if (this.type === 'townhouses') {
        this.activeProperties.forEach(property => {
          if (property.active && property.dwelling && property.dwelling.houseDesign) {
            designs.push({
              label: property.dwelling.houseDesign,
              value: property.dwelling.houseDesign
            })
          }
        })
      }

      designs = _.sortBy(_.uniqBy(designs, 'label'), 'label')
      designs.unshift({ label: 'Any', value: '' })
      return designs
    },

    inputBaths: {
      get () {
        return this.$store.state.filter.inputBaths
      },
      set (value) {
        this.$store.commit('filter/SET_FILTER_PARAMETERS', {
          inputBaths: value
        })
      }
    },

    inputBeds: {
      get () {
        return this.$store.state.filter.inputBeds
      },
      set (value) {
        this.$store.commit('filter/SET_FILTER_PARAMETERS', {
          inputBeds: value
        })
      }
    },

    inputCars: {
      get () {
        return this.$store.state.filter.inputCars
      },
      set (value) {
        this.$store.commit('filter/SET_FILTER_PARAMETERS', {
          inputCars: value
        })
      }
    },

    inputBuilder: {
      get () {
        return this.$store.state.filter.inputBuilder
      },
      set (value) {
        this.$store.commit('filter/SET_FILTER_PARAMETERS', {
          inputBuilder: value
        })
      }
    },

    inputColourScheme: {
      get () {
        return this.$store.state.filter.inputColourScheme
      },
      set (value) {
        this.$store.commit('filter/SET_FILTER_PARAMETERS', {
          inputColourScheme: value
        })
      }
    },

    inputHouseDesign: {
      get () {
        return this.$store.state.filter.inputHouseDesign
      },
      set (value) {
        console.log('SET', value)
        
        this.$store.commit('filter/SET_FILTER_PARAMETERS', {
          inputHouseDesign: value
        })
      }
    },

    inputLotSizeRange: {
      get () {
        return this.$store.getters['filter/lotSizeRanges']
      },
      set (value) {
        this.$store.commit('filter/SET_FILTER_PARAMETERS', {
          inputLotSizeRange: value
        })
      }
    },

    inputDwellingSizeRange: {
      get () {
        return this.$store.getters['filter/dwellingSizeRanges']
      },
      set (value) {
        this.$store.commit('filter/SET_FILTER_PARAMETERS', {
          inputDwellingSizeRange: value
        })
      }
    },

    inputPriceRange: {
      get () {
        return this.$store.getters['filter/priceRanges']
      },
      set (value) {
        this.$store.commit('filter/SET_FILTER_PARAMETERS', {
          inputPriceRange: value
        })
      }
    },

    inputDwellingPriceRange: {
      get () {
        return this.$store.getters['filter/priceRanges']
      },
      set (value) {
        this.$store.commit('filter/SET_FILTER_PARAMETERS', {
          inputPriceRange: value
        })
      }
    },

    inputLotNumber: {
      get () {
        return this.$store.state.filter.inputLotNumber
      },
      set (value) {
        this.$store.commit('filter/SET_FILTER_PARAMETERS', {
          inputLotNumber: value
        })
      }
    },

    packages () {
      return this.$store.getters['property/livingOptionsPackages']
    },

    dwellings () {
      return this.$store.getters['property/livingOptionsDwellings']
    },

    townhouses () {
      return this.$store.getters['property/livingOptionsTownhouses']
    },

    activeProperties () {
      return this.$store.getters['property/activeProperties']
    },

    activeSubsections () {
      return this.$store.getters['property/activeSubsections']
    },

    activePackages () {
      return this.$store.getters['property/livingOptionsPackages']
    },

    filterType () {
      return ['packages', 'package-modal'].includes(this.$store.state.route.name) ? 'packages' : this.$store.state.route.name
    },

    styleTemplate () {
      return this.$store.state.styleTemplate
    }
  },

  mounted () {
    if (this.filterType === 'packages') {
      this.setDisabledRadioSelectionsPackages()
    } else if (this.filterType === 'dwellings') {
      this.setDisabledRadioSelectionsDwellings()
    } else {
      this.setDisabledRadioSelections()
    }
  },

  methods: {
    getActiveSelections (selections) {
      // return length of disabled selections
      return selections.filter(selection => !selection.disabled).length

    },

    setDisabledRadioSelectionsDwellings () {
      let bathValues = []
      let bedValues = []
      let carValues = []

      bathValues = _.uniq(this.dwellings.map(dwelling => {
        return parseInt(dwelling.baths)
      }))

      carValues = _.uniq(this.dwellings.map(dwelling => {
        return parseInt(dwelling.cars)
      }))

      bedValues = _.uniq(this.dwellings.map(dwelling => {
        return parseInt(dwelling.beds)
      }))

      carValues = _.uniq(carValues)
      bathValues = _.uniq(bathValues)
      bedValues = _.uniq(bedValues)

      this.bathsSelections.forEach(selection => {
        if (_.includes(bathValues, selection.value)) {
          selection['disabled'] = false
        } else {
          selection['disabled'] = true
        }
      })

      this.carsSelections.forEach(selection => {
        if (_.includes(carValues, selection.value)) {
          selection['disabled'] = false
        } else {
          selection['disabled'] = true
        }
      })

      this.bedsSelections.forEach(selection => {
        if (_.includes(bedValues, selection.value)) {
          selection['disabled'] = false
        } else {
          selection['disabled'] = true
        }
      })
    },

    setDisabledRadioSelectionsPackages () {
      let bathValues = []
      let bedValues = []
      let carValues = []

      bathValues = _.uniq(this.packages.map(_package => {
        return parseInt(_package.dwelling.baths)
      }))

      carValues = _.uniq(this.packages.map(_package => {
        return parseInt(_package.dwelling.cars)
      }))

      bedValues = _.uniq(this.packages.map(_package => {
        return parseInt(_package.dwelling.beds)
      }))

      carValues = _.uniq(carValues)
      bathValues = _.uniq(bathValues)
      bedValues = _.uniq(bedValues)

      this.bathsSelections.forEach(selection => {
        if (_.includes(bathValues, selection.value)) {
          selection['disabled'] = false
        } else {
          selection['disabled'] = true
        }
      })

      this.carsSelections.forEach(selection => {
        if (_.includes(carValues, selection.value)) {
          selection['disabled'] = false
        } else {
          selection['disabled'] = true
        }
      })

      this.bedsSelections.forEach(selection => {
        if (_.includes(bedValues, selection.value)) {
          selection['disabled'] = false
        } else {
          selection['disabled'] = true
        }
      })
    },

    setDisabledRadioSelections () {
      let bathValues = []
      let bedValues = []
      let carValues = []

      if (this.activeProperties.length) {
        carValues = _.uniq(this.activeProperties.map(property => {
          if (property.dwelling && property.dwelling.cars) {
            return parseInt(property.dwelling.cars)
          }
        }))

        bathValues = _.uniq(this.activeProperties.map(property => {
          if (property.dwelling && property.dwelling.baths) {
            return parseInt(property.dwelling.baths)
          }
        }))

        bedValues = _.uniq(this.activeProperties.map(property => {
          if (property.dwelling && property.dwelling.beds) {
            return parseInt(property.dwelling.beds)
          }
        }))
      }

      if (this.activeSubsections.length) {
        let activeSubsectionsCarValues = this.activeSubsections.map(subsection => {
          return subsection.filter.carRange
        })

        let activeSubsectionsBathValues = this.activeSubsections.map(subsection => {
          return subsection.filter.bathRange
        })

        let activeSubsectionsBedValues = this.activeSubsections.map(subsection => {
          return subsection.filter.bedRange
        })

        let carValuesMerged = [].concat.apply([], activeSubsectionsCarValues)
        let bathValuesMerged = [].concat.apply([], activeSubsectionsBathValues)
        let bedValuesMerged = [].concat.apply([], activeSubsectionsBedValues)

        carValues.push(...carValuesMerged)
        bathValues.push(...bathValuesMerged)
        bedValues.push(...bedValuesMerged)
      }

      carValues = _.uniq(carValues)
      bathValues = _.uniq(bathValues)
      bedValues = _.uniq(bedValues)

      this.bathsSelections.forEach(selection => {
        if (_.includes(bathValues, selection.value)) {
          selection['disabled'] = false
        } else {
          selection['disabled'] = true
        }
      })

      this.carsSelections.forEach(selection => {
        if (_.includes(carValues, selection.value)) {
          selection['disabled'] = false
        } else {
          selection['disabled'] = true
        }
      })

      this.bedsSelections.forEach(selection => {
        if (_.includes(bedValues, selection.value)) {
          selection['disabled'] = false
        } else {
          selection['disabled'] = true
        }
      })
    },

    updateSelectedRange (type, value) {
      if (type === 'price') {
        this.selectedPriceRange = value
      }

      if (type === 'lotSize') {
        this.selectedLotSizeRange = value
      }

      if (type === 'dwellingSize') {
        this.selectedDwellingSizeRange = value
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";

label {
  color: $lime;
}

.property-filter {
  &__header {
    font-size: 1.6rem;
    font-weight: 100;
    letter-spacing: .1rem;
    line-height: 1.2;
    margin: 0 0 2rem;
    text-transform: uppercase;
  }

  &__input {
    margin-bottom: 1.5rem;

    &:last-child {
      margin-bottom: 0rem;
    }
  }
}
</style>